import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentModel} from "../../angular/models/agent.model";
import {ItinerariesService} from "../../../itineraries/services/itineraries-service.service";
import {AgentsFacadeService} from "../../angular/state/agents-facade.service";
import {Subscription} from "rxjs";
import {ItinerariesFacadeService} from "../../../itineraries/angular/services/itineraries-facade.service";
import {TasksFacadeService} from "../../../tasks/angular/services/tasks-facade.service";
import {ItineraryModel} from "../../../itineraries/angular/models/itinerary.model";
import {TaskModel} from "../../../tasks/models/task.model";
import {AgentStatusType} from "../../types/agentStatus.type";

export class AgentListItinerariesSectionCtrl implements IController {

  selectedAgent: AgentModel;
  agentsGroup: any;
  agentType: any;
  agentSkills: any;
  tags: any;
  queryString: string;
  branchIds: any;
  teamIds: string[];
  agentIds: string[];
  enableDriverButton: boolean;
  enableItineraryButton: boolean;
  isItineraryMode: boolean;
  enableChangeDriverStatus: boolean;
  isMinimizedData: boolean;

  onAgentSelect: Function;
  onAgentsGroupChange: Function;

  public agents: AgentModel[];
  public loading: boolean;
  private loadLimit: number;
  public agentTypes: any;
  public totals: any;
  private itinerary: ItineraryModel;
  private tasks: TaskModel[];
  public infiniteScrollAgentsSubscription: Subscription;
  public infiniteScrollLoadingSubscription: Subscription;
  public isLoadingAgents: boolean;
  public itinerariesSubscription: Subscription;
  public tasksSubscription: Subscription;
  public itinerarySearchQuery: string;
  public agentStatusTypes: typeof AgentStatusType = AgentStatusType;

  constructor(private agentRequests: AgentRequests, private agentConstants, private $timeout, private itinerariesService: ItinerariesService, private $log, private $scope: IScope,
              private agentsFacadeService: AgentsFacadeService, private itinerariesFacadeService: ItinerariesFacadeService, private tasksFacadeService: TasksFacadeService) {
  }

  $onInit() {
    this.loadLimit = 20;
    this.agentTypes = this.agentConstants.types;
    this.itinerary = undefined;
    this.tasks = undefined;
    this.totals = {
      onDuty: '--',
      offDuty: '--',
      total: '--'
    };

    if (!this.branchIds) {
      this.branchIds = [];
    }

    if (this.selectedAgent && this.isItineraryMode) {
      this._getAgentItinerary(this.selectedAgent.id);
      // this.onRefreshAgentItinerary(this.selectedAgent);
    } else {
      this.getTotals();
    }

    this.itinerariesFacadeService.subscribeToChannels();
    this.itinerariesSubscription = this.itinerariesFacadeService.selectAll().subscribe(itineraries => {

      const agentItinerary = itineraries?.find(i => i.id === this.selectedAgent?.id);
      if (!agentItinerary) {
        this.itinerary = undefined;
        return;
      }
      this.itinerary = agentItinerary;

      this._setTasks();

      this.$timeout(0).then(() => {
      });
    })

    this.tasksFacadeService.subscribeToChannels();
    this.tasksSubscription = this.tasksFacadeService.selectAll().subscribe(tasks => {
      if (!tasks?.length) {
        return;
      }

      const activeTaskIds = this.itinerary?.taskIdListExt;

      this.tasks = tasks.filter(t => !!activeTaskIds?.includes(t.id)) || [];
      this.tasks.sort((a, b) => {
        return activeTaskIds.indexOf(a.id) - activeTaskIds.indexOf(b.id);
      })

      this.$timeout(0).then(() => {
      });
    })

    this._getAgents();
    this.agentsFacadeService.subscribeToChannels();

    this.infiniteScrollAgentsSubscription = this.agentsFacadeService.selectInfiniteScrollEntities().subscribe((agents: AgentModel[]) => {
      if (!!this.agentIds?.length) {
        this._initTotals(agents);
        if (this.agentsGroup === 'Total') {
          this.agents = angular.copy(agents);
        } else {
          this.agents = agents.filter(agent => {
            if (this.agentsGroup === 'Active' && (agent.status === this.agentStatusTypes.OnDuty || agent.status === this.agentStatusTypes.OnDutyOnBreak)) {
              return true;
            } else if (this.agentsGroup === 'OffDuty' && agent.status === this.agentStatusTypes.OffDuty) {
              return true;
            }
            return false;
          })
        }
      } else {
        this.agents = angular.copy(agents);
      }
      this.$timeout(() => {
      }, 0)
    })

    this.infiniteScrollLoadingSubscription = this.agentsFacadeService.selectInfiniteScrollLoadingState()
      .subscribe(isLoading => {
        this.isLoadingAgents = angular.copy(isLoading);
        this.$timeout(() => {
        }, 0)
      });
  }


  $onChanges(changes) {
    if ((changes.agentsGroup && !changes.agentsGroup.isFirstChange()) ||
      (changes.agentType && !changes.agentType.isFirstChange()) ||
      (changes.agentSkills && !changes.agentSkills.isFirstChange()) ||
      (changes.tags && !changes.tags.isFirstChange()) ||
      (changes.teamIds && !changes.teamIds.isFirstChange()) ||
      (changes.agentIds && !changes.agentIds.isFirstChange()) ||
      (changes.branchIds && !changes.branchIds.isFirstChange()) ||
      (changes.queryString && !changes.queryString.isFirstChange())) {
      this._getAgents();
      this.getTotals();
    }
    if (changes.selectedAgent && !changes.selectedAgent.isFirstChange()) {
      if (this.isItineraryMode) {
        if (!!this.itinerary) {
          this.itinerariesFacadeService.removeByIds([this.itinerary?.id]);
        }
        if (!!this.tasks?.length) {
          this.tasksFacadeService.removeByIds(this.tasks.map(t => t.id));
        }

        if (!!this.selectedAgent) {
          this._getAgentItinerary(this.selectedAgent.id);
        }
      }
    }
    if (changes.isItineraryMode && !changes.isItineraryMode.isFirstChange()) {
      if (!this.isItineraryMode) {
        this.getTotals();
      }
    }
  };


  $onDestroy() {

    this.itinerariesSubscription?.unsubscribe();
    this.itinerariesFacadeService?.unsubscribeFromChannels();

    this.tasksSubscription?.unsubscribe();
    this.tasksFacadeService?.unsubscribeFromChannels();

    this.agentsFacadeService?.unsubscribeFromChannels();
    this.infiniteScrollAgentsSubscription?.unsubscribe();
    this.infiniteScrollLoadingSubscription?.unsubscribe();
  }

  getTotals() {

    if (!!this.agentIds?.length) {
      return;
    }
    this.agentRequests.getAgentTotals(this._getTotalsQueryPayload())
      .then((totals) => {
        this.totals = {
          onDuty: totals.onDuty + totals.onDutyOnBreak,
          offDuty: totals.offDuty,
          total: totals.total
        };
      })
      .catch((error) => {
        this.$log.error('Failed to get totals, teamDrivers@reloadTotals', error);
      })
  }

  onItinerarySearchQuery(query) {
    this.itinerarySearchQuery = query;
  }

  onItineraryClick(agent) {
    this.isItineraryMode = true;
    if (!!this.itinerary) {
      this.itinerariesFacadeService.removeByIds([this.itinerary?.id]);
    }
    if (!!this.tasks?.length) {
      this.tasksFacadeService.removeByIds(this.tasks.map(t => t.id));
    }

    this._getAgentItinerary(agent.id);
    this.onAgentSelect({agent: agent});
  }

  onRefreshAgentItinerary(agent) {
    this.tasks = undefined;
    this.loading = true;
    this.agentRequests.refreshAgentItinerary(agent.id, false)
      .then((updatedItinerary: ItineraryModel) => {
        this.itinerariesFacadeService.setOne(updatedItinerary);
      })
      .catch((error) => {
        this.$log.error('Failed to get analysis by agent', error);
      })
      .finally(() => {
        this.loading = false;
      })
  }

  fetchNext() {
    if (this.isLoadingAgents) return;
    this.agentsFacadeService.fetchNext(this._getQueryPayload(), true);
  }

  // ******************************
  //        Internal methods
  // ******************************

  private _getAgents() {
    this.agentsFacadeService.clearStore();
    this.agentsFacadeService.getInfiniteScrollEntities(this._getQueryPayload(), true);
  }

  private _getQueryPayload() {
    const params = {
      group: this._getGroup(),
      status: this._getStatus(),
      agentTypes: this.agentType,
      skill: this.agentSkills,
      branchIds: this.branchIds,
      query: this.queryString,
      limit: this.loadLimit,
      tags: this.tags,
      ids: this.agentIds,
      teamIds: this.teamIds,
      sortByLoad: true,
      active: true
    };

    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
    return params;
  }

  private _getTotalsQueryPayload() {
    return {
      active: true,
      branchIds: this.branchIds,
      agentTypes: this.agentType,
      skill: this.agentSkills,
      tags: this.tags,
      ids: this.agentIds,
      teamIds: this.teamIds,
      query: this.queryString,
    };
  }

  private _getGroup() {
    return this.agentsGroup === 'Active' ? 'Active' : undefined;
  }

  private _getStatus() {
    return this.agentsGroup === 'OffDuty' ? 'OffDuty' : undefined;
  }

  private _getAgentItinerary(agentId) {
    if (!agentId) {
      return;
    }
    this.itinerariesFacadeService.getMany([agentId], true);
  }

  private _setTasks() {

    let oldActiveTasks = this.tasks?.map(t => t.id) || [];
    let newActiveTasks = this.itinerary.taskIdListExt;

    const taskIdsToAdd: string[] = _.difference(newActiveTasks, oldActiveTasks);
    const taskIdsToRemove: string[] = _.difference(oldActiveTasks, newActiveTasks);

    if (!!taskIdsToRemove.length) {
      this.tasksFacadeService.removeByIds(taskIdsToRemove);
    }

    if (!!taskIdsToAdd.length) {
      this.tasksFacadeService.getByIds(taskIdsToAdd);
    }
  }

  private _initTotals(agents) {

    this.totals = {
      onDuty: 0,
      offDuty: 0,
      total: agents?.length || 0
    };

    if (!agents?.length) return;

    agents?.forEach(agent => {
      if (agent.status === this.agentStatusTypes.OnDuty || agent.status === this.agentStatusTypes.OnDutyOnBreak) {
        this.totals.onDuty++;
      } else {
        this.totals.offDuty++;
      }
    })
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentListItinerariesSection', {
    bindings: {
      selectedAgent: '<',
      agentsGroup: '<',
      agentType: '<?',
      agentSkills: '<?',
      tags: '<?',
      queryString: '<?',
      branchIds: '<',
      teamIds: '<?',
      agentIds: '<?',
      enableDriverButton: '<?',
      enableItineraryButton: '<?',
      isItineraryMode: '<?',
      enableChangeDriverStatus: '<?',
      isMinimizedData: '<?',
      onAgentSelect: '&',
      onAgentsGroupChange: '&'
    },
    template: require('./agent-list-itineraries-section.html').default,
    controller: AgentListItinerariesSectionCtrl
  });
